import React from "react";

import dayjs from "dayjs";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

function InputDate({ label, value, onChange, disabled = false }) {
  const handleDateChange = (value) => {
    onChange(dayjs(value).format("YYYY-MM-DD"));
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disabled={disabled}
        label={label}
        value={value}
        onChange={handleDateChange}
        format="dd/MM/yyyy"
        margin="dense"
        orientation="landscape"
        clearLabel="Limpar"
        clearable={true}
        cancelLabel="Cancelar"
        showTodayButton={true}
        todayLabel="Hoje"
        autoOk={true}
        InputLabelProps={{ shrink: true }}
        inputProps={{
          margin: "dense",
        }}
        inputVariant="outlined"
        invalidDateMessage=""
      />
    </MuiPickersUtilsProvider>
  );
}

export default InputDate;
